import * as React from "react";

function IconDefaultProfile(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 52 52" fill="none" {...props}>
      <rect width={52} height={52} rx={16} fill="#EAEBEC" />
      <rect
        x={0.5}
        y={0.5}
        width={51}
        height={51}
        rx={15.5}
        stroke="#000"
        strokeOpacity={0.02}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.887 20.644a4.897 4.897 0 01-4.894 4.896 4.896 4.896 0 114.894-4.896zm-4.895 6.393c-7.049 0-9.79 4.486-9.79 6.573 0 2.086 5.836 2.642 9.79 2.642 3.954 0 9.791-.556 9.791-2.642 0-2.087-2.742-6.573-9.79-6.573z"
        fill="#989BA2"
      />
    </svg>
  );
}

const MemoIconDefaultProfile = React.memo(IconDefaultProfile);
export default MemoIconDefaultProfile;
